@if (showLdr) {
<ds-loading></ds-loading>
}
<nz-drawer
  [nzWidth]="'80%'"
  [nzClosable]="true"
  [nzVisible]="visibleVhclSldr"
  nzPlacement="right"
  nzTitle="Vehicle Dashboard"
  (nzOnClose)="visibleVhclSldr = false"
  class="dashbSlider"
>
  @if (selectedVehicle) {
  <app-vehicle-slider [vechile]="selectedVehicle"></app-vehicle-slider>
  }
</nz-drawer>
<div class="row">
  <div class="col-lg-12 col-md-12 mg-a">
    <div class="row hdrBar">
      <div class="col-lg-12 col-md-12 mg-a">
        <h1>Distance Approval</h1>
      </div>
    </div>
  </div>
</div>
<div class="fltrbg">
  <div class="row">
    @if (tntLst.length>1) {
    <div class="col-lg-2 col-md-2 crdCl">
      <p class="slctlbl">Select ULB</p>
      <nz-select
        class="slctBx"
        nzShowSearch
        [(ngModel)]="selectedtenant"
        nzPlaceHolder="Select ULB"
        (ngModelChange)="ontntSelect($event)"
        [ngModelOptions]="{ standalone: true }"
      >
        <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
        @for (t of tntLst; track t) {
        <nz-option [nzValue]="t.tnt_id" [nzLabel]="t.tnt_nm"></nz-option>
        }
      </nz-select>
    </div>
    } @if (tntLst.length==1) {
    <div class="col-lg-2 col-md-2 crdCl">
      <p class="slctlbl">ULB</p>
      <p class="slctlbl">{{ tntLst[0].tnt_nm }}</p>
    </div>
    }
    <div class="col-lg-2 col-md-2 crdCl">
      <span>Select Date:</span>
      <nz-date-picker
        [nzDisabledDate]="disabledDate"
        [nzFormat]="dateFormat"
        [(ngModel)]="slctdDt"
        (ngModelChange)="onChange($event)"
      ></nz-date-picker>
    </div>
  </div>
</div>
<div class="main">
  <div class="row bg-wp">
    <h1 style="font-size: 20px">Distance Updated Vehicles</h1>
    <nz-tabs nzType="card" (nzSelectChange)="tabchange($event)">
      <nz-tab nzTitle="Pending">
        <div class="ds-card grid tbl">
          <app-data-grid
            [allowedPageSizes]="[10, 20, 30, 50]"
            id="gridContainer"
            style="width: 100%"
            [dataSource]="unaprvdData"
            [legacyColumns]="columnDefs"
            [searchPanel]="true"
            [filterRow]="true"
            [filterPanel]="false"
            [groupPanel]="true"
            [columnChooser]="true"
            [allowExport]="true"
            exportFileName="vehicle distance approved Data"
            [pageSize]="10"
            [rowAlternationEnabled]="true"
            [showBorders]="true"
            [wordWrapEnabled]="true"
          >
            <app-grid-column
              [showInColumnChooser]="false"
              [visible]="true"
              type="buttons"
              [width]="100"
              caption="Approve"
              cellTemplate="editTemplate"
            ></app-grid-column>
            <ng-template appGridCell="editTemplate" let-data="cell"
              ><div>
                <div class="tblEdtBtn" (click)="approve(data)">Approve</div>
              </div></ng-template
            >

            <app-grid-column
              [showInColumnChooser]="false"
              [visible]="true"
              type="buttons"
              [width]="100"
              caption="Reject"
              cellTemplate="editTemplate2"
            ></app-grid-column>
            <ng-template appGridCell="editTemplate2" let-data="cell"
              ><div>
                <div class="tblEdtBtn" (click)="rejectslider(data)">Reject</div>
              </div></ng-template
            >

            <app-grid-column
              [showInColumnChooser]="false"
              [visible]="true"
              type="buttons"
              [width]="100"
              caption="View"
              cellTemplate="editTemplate1"
            ></app-grid-column>
            <ng-template appGridCell="editTemplate1" let-data="cell"
              ><div>
                <div class="tblEdtBtn" (click)="getVehDashSldr(data)">
                  <i nz-icon nzType="car" nzTheme="outline"></i>
                </div></div
            ></ng-template>
          </app-data-grid>
        </div>
      </nz-tab>
      <nz-tab nzTitle="Approved">
        <div class="ds-card grid tbl">
          <app-data-grid
            [allowedPageSizes]="[10, 20, 30, 50]"
            id="gridContainer"
            style="width: 100%"
            [dataSource]="aprvdData"
            [legacyColumns]="columnDefs1"
            [searchPanel]="true"
            [filterRow]="true"
            [filterPanel]="false"
            [groupPanel]="true"
            [columnChooser]="true"
            [allowExport]="true"
            exportFileName="vehicle distance approved Data"
            [pageSize]="10"
            [rowAlternationEnabled]="true"
            [showBorders]="true"
            [wordWrapEnabled]="true"
          >
            <app-grid-column
              [showInColumnChooser]="false"
              [visible]="true"
              type="buttons"
              [width]="100"
              caption="View"
              cellTemplate="editTemplate1"
            ></app-grid-column>
            <ng-template appGridCell="editTemplate1" let-data="cell"
              ><div>
                <div class="tblEdtBtn" (click)="getVehDashSldr(data)">
                  <i nz-icon nzType="car" nzTheme="outline"></i>
                </div></div
            ></ng-template>
          </app-data-grid>
        </div>
      </nz-tab>
      <nz-tab nzTitle="Rejected">
        <div class="ds-card grid tbl">
          <app-data-grid
            [allowedPageSizes]="[10, 20, 30, 50]"
            id="gridContainer"
            style="width: 100%"
            [dataSource]="rjctData"
            [legacyColumns]="columnDefs2"
            [searchPanel]="true"
            [filterRow]="true"
            [filterPanel]="false"
            [groupPanel]="true"
            [columnChooser]="true"
            [allowExport]="true"
            exportFileName="vehicle distance approved Data"
            [pageSize]="10"
            [rowAlternationEnabled]="true"
            [showBorders]="true"
            [wordWrapEnabled]="true"
          >
            <app-grid-column
              [showInColumnChooser]="false"
              [visible]="true"
              type="buttons"
              [width]="100"
              caption="View"
              cellTemplate="editTemplate1"
            ></app-grid-column>
            <ng-template appGridCell="editTemplate1" let-data="cell"
              ><div>
                <div class="tblEdtBtn" (click)="getVehDashSldr(data)">
                  <i nz-icon nzType="car" nzTheme="outline"></i>
                </div></div
            ></ng-template>
          </app-data-grid>
        </div>
      </nz-tab>
    </nz-tabs>
  </div>
</div>
<nz-drawer
  [nzWidth]="'20%'"
  [nzClosable]="true"
  [nzVisible]="vsbleRjct"
  nzPlacement="right"
  nzTitle="Reject Distance Approval"
  (nzOnClose)="vsbleRjct = false"
  class="dashbSlider"
>
  <div class="row drvrDtlsfrm">
    <div class="vehicleno">
      <div class="row vhcl">
        <div class="col-md-8 vhclelbl">Vehicle Registration Number</div>
        <div class="col-md-4 vhclNbrClr">
          {{ asrt_nm }}
        </div>
      </div>
      <div class="row">
        <div class="col-md-8 vhclelbl">Distance Updated On</div>
        <div class="col-md-4 vhclNbrClr">
          {{ dst_updtn_dt }}
        </div>
      </div>
      <div class="row vhcl">
        <div class="col-md-8 vhclelbl">Updated Distance</div>
        <div class="col-md-4 vhclNbrClr">
          {{ updt_dst }}
        </div>
      </div>
    </div>
    <div nz-row [nzGutter]="4">
      <div nz-col nzSpan="24">
        <nz-form-label>Reason for Rejection</nz-form-label>
        <nz-form-item>
          <nz-form-control>
            <input
              nz-input
              [(ngModel)]="rjctrsn"
              placeholder="Reason for Rejection"
              [ngModelOptions]="{ standalone: true }"
            />
          </nz-form-control>
        </nz-form-item>
      </div>
      <div class="btngrp">
        <button
          nz-button
          style="margin-right: 8px"
          (click)="closeSideBar()"
          nzType="primary"
          nzDanger
        >
          Cancel
        </button>
        <button nz-button (click)="reject()" nzType="primary" class="sbmtbtn">
          Submit
        </button>
      </div>
    </div>
  </div>
</nz-drawer>
